import { useDispatch } from 'react-redux';
import { AppDispatch } from '../../../redux/store';
import { useState } from 'react';
import {
  postGetEvaluationMCAnswers,
  EvaluationAnswersPayload,
} from '../reducers/postEvaluationMCAnswers';

const usePostEvaluationMCAnswers = () => {
  const dispatch = useDispatch<AppDispatch>();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<unknown>();

  const postEvaluationResponseMCAnswers = async (
    requestPayload: EvaluationAnswersPayload,
  ) => {
    try {
      const resultAction = await dispatch(postGetEvaluationMCAnswers(requestPayload));
      if (postGetEvaluationMCAnswers.fulfilled.match(resultAction)) {
        setLoading(false);
      }
    } catch (error) {
      setError(error);
    }finally{
      setLoading(false)
    }
  };

  return { loading, error, postEvaluationResponseMCAnswers };
};

export default usePostEvaluationMCAnswers;
